module.exports = __webpack_public_path__ + "static/media/QuantitativeIcon.0ee7d125.svg";